import * as React from 'react';
import { FormGroup, FormSelect, FormSelectOption } from '@patternfly/react-core';
import {
  CHART_WINDOWS,
  CHART_WINDOW_LABELS,
  type ChartWindow,
  type WindowCoverage,
} from '../../../../../shared/riskregister/executiveCharts';

function monthWord(count: number): string {
  return `${count} month${count === 1 ? '' : 's'}`;
}

/**
 * Window picker for the month-end charts. Each chart owns its own value, so one can sit on 90 days
 * while another shows the full year. When the register is younger than the window, the note says so
 * rather than letting a short series look like the window was honoured.
 */
export const ChartWindowSelect: React.FunctionComponent<{
  id: string;
  value: ChartWindow;
  onChange: (window: ChartWindow) => void;
  coverage: WindowCoverage;
}> = ({ id, value, onChange, coverage }) => (
  <div className="risk-register__chart-window">
    <FormGroup label="Show" fieldId={id}>
      <FormSelect
        id={id}
        value={value}
        onChange={(_event, next) => onChange(next as ChartWindow)}
        aria-describedby={coverage.clamped ? `${id}-coverage` : undefined}
      >
        {CHART_WINDOWS.map((window) => (
          <FormSelectOption key={window} value={window} label={CHART_WINDOW_LABELS[window]} />
        ))}
      </FormSelect>
    </FormGroup>
    {coverage.clamped && (
      <p className="risk-register__chart-coverage" id={`${id}-coverage`}>
        The register only goes back {monthWord(coverage.shown)}, so this shows all of it rather than{' '}
        {monthWord(coverage.requested)}.
      </p>
    )}
  </div>
);
